import { BackgroundInfoType } from '../enums/background-info-type';
import { BackgroundInfo } from '../background-info';

export class CreateBackgroundInfoTemplatePayload {
  useCase: BackgroundInfoType;
  activeJurisdiction: BackgroundInfo;
  objectId: number;
  code: any;
}
